module.exports = __webpack_public_path__ + "static/media/hiddenDebtIcon_white.4351ac69.png";